//SECTION CHECKBOX

import { gql, useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import * as yup from 'yup';
import { addMessage, resetMessage } from "../../../../../stores/ReactiveVariables";
import { AccordionCheckbox } from "../AccordionCheckbox";

const GET_COVER_LETTER_PROJECT_DESCRIPTION_SECTION = gql`
    query GetCoverLetterProjectDescription($Id: uniqueidentifier = "") {
        BidQuotes_by_pk(Id: $Id) {
            CoverLetterProjectDescriptionSection
        }
    }  
`;

const UPDATE_COVER_LETTER_PROJECT_DESCRIPTION_SECTION = gql`
    mutation UpdateCoverLetterProjectDescriptionSection($Id: uniqueidentifier = "", $CoverLetterProjectDescriptionSection: Boolean = false) {
        update_BidQuotes_by_pk(pk_columns: {Id: $Id}, _set: {CoverLetterProjectDescriptionSection: $CoverLetterProjectDescriptionSection}) {
            __typename
            Id
        }
    }
`;

interface ProjectDescriptionCheckboxProps {
    id: string;
    getCoverLetter: () => void;
}

const validationSchema = yup.object().shape({
    CoverLetterProjectDescriptionSection: yup.boolean(),
});

export const ProjectDescriptionCheckbox: React.FC<ProjectDescriptionCheckboxProps> = ({ id, getCoverLetter }: ProjectDescriptionCheckboxProps) => {
    const { data, loading, error } = useQuery(GET_COVER_LETTER_PROJECT_DESCRIPTION_SECTION, { variables: { Id: id } });
    const [updateCoverLetterExecutionPlan] = useMutation(UPDATE_COVER_LETTER_PROJECT_DESCRIPTION_SECTION);

    const formData = data?.BidQuotes_by_pk;

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            CoverLetterProjectDescriptionSection: formData?.CoverLetterProjectDescriptionSection ?? false,
        },
        onSubmit: (values: any) => {
            updateCoverLetterExecutionPlan({
                variables: { Id: id, CoverLetterProjectDescriptionSection: values.CoverLetterProjectDescriptionSection },
                onCompleted: (data: any) => {
                    resetMessage();
                    const confirmMessage = values.CoverLetterProjectDescriptionSection === true ? "Project Description Added To Cover Letter" : "Project Description Removed From Cover Letter";
                    addMessage(confirmMessage, { severity: 'success' });
                    getCoverLetter();
                },
                onError: () => {
                    addMessage('Error Saving/Removing Project Description', { severity: 'error' });
                }
            });
        }
    });
    return (
        <AccordionCheckbox
            getCoverLetter={getCoverLetter}
            name="CoverLetterProjectDescriptionSection"
            checked={formik.values.CoverLetterProjectDescriptionSection}
            onCheckboxClick={() => formik.setFieldValue('CoverLetterProjectDescriptionSection', !formik.values.CoverLetterProjectDescriptionSection)}
            onSave={formik.submitForm}
            loading={loading}
        />
    )
}
